import { j as s } from "../jsx-runtime-ClSzPYp4.js";
import { styled as t, css as d } from "styled-components";
import { space as r } from "styled-system";
const i = /* @__PURE__ */ t.legend.withConfig({
  shouldForwardProp: (o) => ![
    "variant"
  ].includes(o)
}).withConfig({
  componentId: "sc-7666b70f-0"
})([
  "",
  " ",
  ""
], ({ theme: o, variant: e }) => /* @__PURE__ */ d([
  "",
  " ",
  ""
], o.components.legend.base, o.components.legend[e]), r), m = ({ variant: o = "dark", children: e, ...n }) => /* @__PURE__ */ s.jsx(i, {
  variant: o,
  ...n,
  children: e
});
export {
  i as StyledLegend,
  m as default
};
